module.exports = __webpack_public_path__ + "static/media/MUS_LoobyMusic_BBGames_Loop.f73cafa8.mp3";